<template>
  <bl-popover-av size="small" trigger="hover" dark>
    <bl-icon-av variant="help" />
    <div slot="content" class="u-pad--3">Pertumbuhan nilai NAB pada {{ this.generateContent() }}</div>
  </bl-popover-av>
</template>

<script>
import BlPopoverAv from '@bukalapak/bazaar-dweb/dist/components/BlPopoverAv';
import BlIconAv from '@bukalapak/bazaar-dweb/dist/components/BlIconAv';
import RodTooltipContentGenerator from 'shared/helpers/RodTooltipContentGenerator';

export default {
  name: 'RodTooltip',
  components: { BlPopoverAv, BlIconAv },
  props: {
    mode: {
      type: String,
      default: 'daily',
    },
  },
  methods: {
    generateContent() {
      const generator = new RodTooltipContentGenerator(this.mode);
      return generator.perform();
    },
  },
};
</script>
